import React from "react";
import useScrollTrigger from "@mui/material/useScrollTrigger";

const ScrollHandler = (props) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100, // Trigger after scrolling 100px
    target: props.window ? window() : undefined,
  });

  return React.cloneElement(props.children, {
    style: {
      color: "white",
      transition: trigger || props.pathname !== "/" ? "0.3s" : "0.5s",
      boxShadow: trigger ? "0 2px 4px rgba(0,0,0,0.1)" : "none",
      padding: "10px 0px",
      position: trigger ? "fixed" : "static",
      top: trigger ? 0 : "auto",
      left: trigger ? 0 : "auto",
      right: trigger ? 0 : "auto",
      zIndex: trigger ? 1100 : "auto",
      // backgroundColor: trigger ? "rgba(255, 255, 255, 0.95)" : "transparent",
      backdropFilter: trigger ? "blur(10px)" : "none",
    },
  });
};

const ScrollToColor = (props) => {
  return <ScrollHandler {...props}>{props.children}</ScrollHandler>;
};

export default ScrollToColor;
